export function optimizeImageUrl(url: string, targetWidth: number): string {
  if (!url) return url;

  try {
    const parsed = new URL(url);

    if (parsed.hostname.includes('muscache.com')) {
      parsed.searchParams.set('im_w', String(targetWidth));
      return parsed.toString();
    }
  } catch {
    // not a valid URL, return as-is
  }

  return url;
}
